"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inverse;
function inverse(value) {
  return !value;
}


//////////////////
// WEBPACK FOOTER
// ./~/react-redux-form/lib/utils/inverse.js
// module id = 989
// module chunks = 0